<template>
  <div class="archives">
    <div class="form-container">
      <div class="flex">
        <span class="title">工种：</span>
        <el-select class="white" clearable v-model="form.workType" placeholder="请选择">
          <el-option
            v-for="item in workTypeList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
        <span class="title">姓名：</span>
        <el-input v-model="form.username" placeholder="请输入"></el-input>
        <el-button class="btn-blue" icon="el-icon-search" @click="searchList">搜索</el-button>
        <el-button icon="el-icon-refresh" class="btn-gray" @click="clearData">重置</el-button>
      </div>
    </div>

    <!-- 档案列表 -->
    <div class="table-container">
      <div class="table">
        <el-table :data="tableData" style="width: 100%">
          <el-table-column
            v-for="(item, index) in tableTitle"
            :key="index"
            :prop="item.prop"
            :label="item.label"
            :width="item.width"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <div v-if="item.prop === 'name'">
                <span>{{ scope.row.name }}</span>
                <img v-if="scope.row.isLeader" class="headman" src="~assets/images/product/headman.png">
              </div>
              <div v-else>
                {{ scope.row[item.prop]}}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button
                class="btn-text"
                type="text"
                @click="updateUser(scope.row)"
              >编辑</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination">
          <pagination-tpl
            :total="total"
            :currentPage="currentPage"
            :pageSize="pageSize"
            @queryChange="queryChange"
          ></pagination-tpl>
        </div>
      </div>
    </div>

    
    <!-- 编辑档案 -->
    <el-drawer
      title="编辑"
      :visible.sync="drawer"
      :wrapperClosable="false"
      :before-close="handleCloseDrawer">
      <el-form ref="archivesForm" :rules="archivesFormRules" :model="archivesForm">
        <el-form-item label="姓名" prop="name">
          <el-input v-model="archivesForm.name" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="phone">
          <el-input v-model="archivesForm.phone" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="身份证" prop="idCard">
          <el-input v-model="archivesForm.idCard" placeholder="请输入" auto-complete="new-password"></el-input>
        </el-form-item>
        <el-form-item label="工种" prop="workType">
          <el-select class="white" clearable v-model="archivesForm.workType" placeholder="请选择">
            <el-option
              v-for="item in workTypeList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="drawer-footer">
        <el-button class="btn-gray" @click="handleCloseDrawer">取消</el-button>
        <el-button class="btn-blue" @click="submitForm('archivesForm')">确定</el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import Archives from "models/archives";
import PaginationTpl from "components/base/PaginationTpl";
import { idCardValidity } from "@/common/js/validate";
import workTypeMixins from "@/common/mixins/work-type";
export default {
  mixins: [workTypeMixins],
  components: {
    PaginationTpl,
  },

  data() {
    // 此处自定义校验手机号码js逻辑
    var phoneReg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
    var validatePhone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('手机号不能为空!'))
      }
      if (!phoneReg.test(value)) {
        callback(new Error('手机号格式有误'))
      } else {
        callback()
      }
    }
    return {
      form: {
        workType: "",
        username: ""
      },
      total: 0,
      currentPage: 1,
      pageSize: 20,
      tableData: [],
      tableTitle: [
        {label: '姓名', prop: 'name', width: ''},
        {label: '手机号', prop: 'phone', width: ''},
        {label: '身份证号', prop: 'idCard', width: ''},
        {label: '工种', prop: 'typeVal', width: ''},
      ],
      drawer: false,
      archivesForm: {
        id: "",
        workType: null,
        name: "",
        phone: '',
        idCard: null,
      },
      archivesFormRules: {
        workType: [{ required: true, message: "请选择工种", trigger: "change" }],
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        phone: [
          { required: true, validator: validatePhone, trigger: "blur" }
        ],
        idCard: [
          { required: true, message: "请输入个人身份证号", trigger: "blur" },
          { pattern: /(^\d{8}(0\d|10|11|12)([0-2]\d|30|31)\d{3}$)|(^\d{6}(18|19|20)\d{2}(0\d|10|11|12)([0-2]\d|30|31)\d{3}(\d|X|x)$)/,message: '请输入正确的个人身份证号',trigger: 'blur' },
          { required: true,validator: idCardValidity, trigger: 'blur' },
        ],
      },
    }
  },

  created() {
    this.initArchivesList()
  },

  methods: {
    /** 
     * @desc 档案列表
    */
    initArchivesList() {
      let type = this.form.workType
      let name = this.form.username
      let currentPage = this.currentPage
      let data = {
        currentPage,
        type,
        name
      }
      Archives.getArchivesList(data).then(res => {
        if (res.success) {
          let arr = [];
          this.total = res.result.totalNum
          this.pageSize = res.result.pageSize
          res.result.items.map(value => {
            let obj = {};
            obj.id = value.id;
            obj.name = value.name;
            // isLeader是否是组长，1、是 0、不是
            obj.isLeader = value.isLeader;
            obj.phone = value.phoneNumber;
            obj.idCard = value.idNumber;
            obj.type = value.type;
            obj.typeVal = this.workTypeObj[value.type]
            arr.push(obj);
          });
          this.tableData = arr;
        }
      });
    },

    searchList() {
      this.currentPage = 1
      this.initArchivesList()
    },

    clearData() {
      this.form.workType = ""
      this.form.username = ""
    },

    /** 
     * @desc 翻页
    */
    queryChange(data) {
      this.currentPage = data.currentPage;
      this.initArchivesList()
    },
    
    /**
     * @desc 编辑
     */
    updateUser(row) {
      this.archivesForm.id = row.id;
      this.archivesForm.name = row.name;
      this.archivesForm.phone = row.phone;
      this.archivesForm.idCard = row.idCard;
      this.archivesForm.workType = row.type;
      this.drawer = true
    },
    
    handleCloseDrawer() {
      this.$refs['archivesForm'].resetFields();
      this.drawer = false
    },
    
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let data = {};
          data.id = this.archivesForm.id;
          data.name = this.archivesForm.name;
          data.phoneNumber = this.archivesForm.phone;
          data.idNumber = this.archivesForm.idCard;
          data.type = this.archivesForm.workType;
          Archives.postUpdateArchvies(data).then(res => {
            if (res.success) {
              this.initArchivesList();
              this.handleCloseDrawer();
              this.$message.success("编辑成功");
            } else {
              this.$message.error(res.message);
            }
          });
        } else {
          return false;
        }
      });
    },
  }
}
</script>

<style lang='scss'>
@import "@/assets/style/layout/production/archives.scss";
</style>
